<template>
  <div>
    <div class="empty-container" v-if="value.length === 0">
      <div @click="handleToggleCollapse">Expand to add choices for this question</div>
    </div>
    <draggable
      class="choice-container"
      group="choices"
      draggable=".draggable"
      v-model="computedValue"
      @click.native="handleToggleCollapse"
    >
      <div
        class="choice"
        v-for="choice in computedValue"
        :class="[choiceScaleClass(choice), { draggable: isEditable }]"
        :key="choice.id"
        @click.stop
      >{{ choice.title }}</div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

import Empty from '@/components/common/Empty';

import { parseChoices } from '../../utils';

export default {
  name: 'ScaleEditorCollapsed',
  components: {
    draggable,

    Empty,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    isReverseOrder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(values) {
        const choices = parseChoices(values);
        const polarisedChoices = this.calculatePolarity(choices);
        const combinedChoices = this.combineChoices(polarisedChoices);

        this.$emit('input', combinedChoices);
      },
    },
    positiveChoices() {
      return this.value.filter(c => c.polarity > 0);
    },
    neutralChoices() {
      return this.value.filter(c => c.polarity === 0);
    },
    negativeChoices() {
      return this.value.filter(c => c.polarity < 0);
    },
  },
  methods: {
    combineChoices(values) {
      const pos = values.filter(c => c.polarity > 0);
      const neu = values.filter(c => c.polarity === 0);
      const neg = values.filter(c => c.polarity < 0);

      const combined = this.isReverseOrder ? [...pos, ...neu, ...neg] : [...neg, ...neu, ...pos];
      const orderedChoices = combined.map((c, idx) => ({ ...c, order: idx + 1 }));
      return orderedChoices;
    },

    choiceScaleClass(choice) {
      const polarity = choice.polarity || 0;
      if (polarity > 0) {
        return 'positive';
      } else if (polarity < 0) {
        return 'negative';
      }
      return 'neutral';
    },

    calculatePolarity(choices) {
      const positive = this.calculatePositivePolarity(choices.filter(c => c.polarity > 0));
      const neutral = this.calculateNeutralPolarity(
        choices.filter(c => c.polarity === 0 || !('polarity' in c)),
      );
      const negative = this.calculateNegativePolarity(choices.filter(c => c.polarity < 0));

      return [...negative, ...neutral, ...positive].sort((a, b) => a.polarity < b.polarity);
    },

    calculatePositivePolarity(choices) {
      return choices.map((c, idx) => ({ ...c, polarity: choices.length - idx }));
    },

    calculateNeutralPolarity(choices) {
      return choices.map(c => ({ ...c, polarity: 0 }));
    },

    calculateNegativePolarity(choices) {
      return choices.map((c, idx) => ({ ...c, polarity: (idx + 1) * -1 }));
    },

    handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/style/_variables_live.scss';

.choice-container {
  line-height: 2;
  cursor: pointer;
}

.choice {
  border: 1px solid #ccc;
  padding: 1px 4px;
  border-radius: 6px;
  font-size: 0.8em;
  margin-right: 4px;
  cursor: default;
  white-space: nowrap;
  display: inline-block;
}

.choice.draggable {
  cursor: grab;
}

.positive.choice {
  background-color: lighten($colony-green, 35%);
  border: 1px solid $colony-green;
}

.neutral.choice {
  background-color: lighten($colony-orange, 35%);
  border: 1px solid $colony-orange;
}

.negative.choice {
  background-color: lighten($colony-red, 25%);
  border: 1px solid $colony-red;
}

.empty-container {
  cursor: pointer;
  margin: 5px 0;
  text-align: center;
  font-size: 0.8em;
  color: #ccc;
  text-shadow: 2px 2px 2px #efefef;
}
</style>



// WEBPACK FOOTER //
// ScaleEditorCollapsed.vue?20f357be